import { render, staticRenderFns } from "./BtnConsumoPorItem.vue?vue&type=template&id=3f12cd1d"
import script from "./BtnConsumoPorItem.vue?vue&type=script&lang=js"
export * from "./BtnConsumoPorItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports